import { Cookies } from '@utopia-utils/core'

type GoOptions = {
  /** 默认是 window.location.origin */
  origin?: string
  path: string
  /**
   * window.open 的 target
   * @default _blank
   */
  target?: '_blank' | '_self'
}

/**
 * 跳转老项目页面
 * @param options
 */
export function goLegacyPage(options: GoOptions) {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-alert
    alert('开发环境不支持')
    return
  }
  const { origin = window.location.origin, path } = options
  const url = `${origin}${path}`

  window.open(url, options.target)
}

/** 跳转老项目的登录页 */
export function legacyLogout() {
  Cookies.remove('JSESSIONID')
  Cookies.remove('MSESSIONID')
  if (window.parent) {
    window.parent.location.replace('/merchant-platform/#/new')
    return
  }

  goLegacyPage({
    path: '',
    target: '_self',
  })
}
